export function TOSUpdatedMessage() {
    return (
        <>
            <p>
                Hi, We've just updated our TOS, please take a moment to read and accept
            </p>
        </>
    )
}